/**
 * @generated SignedSource<<38626ff8705a6c0de9b2d1e6d56973af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useFetchSuggestionCount_query$data = {
  readonly confluence_remoteObjectSuggestionCount: number | null;
  readonly " $fragmentType": "useFetchSuggestionCount_query";
};
export type useFetchSuggestionCount_query$key = {
  readonly " $data"?: useFetchSuggestionCount_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFetchSuggestionCount_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "spaceKey"
    }
  ],
  "kind": "Fragment",
  "name": "useFetchSuggestionCount_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "kind": "ScalarField",
      "name": "confluence_remoteObjectSuggestionCount"
    }
  ],
  "type": "Query"
};

(node as any).hash = "b4d0196e6c2004ac771cb71891cd74af";

export default node;
